import { httpClient } from '../http/httpClient'

export enum UserRoleEnum {
  SUPER_ADMIN = 'SUPER_ADMIN',
  ADMIN = 'ADMIN',
  USER = 'USER',
  MANAGER = 'MANAGER',
  SUPERVISOR = 'SUPERVISOR',
  LEADER = 'LEADER',
  SUPPORT = 'SUPPORT',
}

export const UserRoleDicionary = {
  SUPER_ADMIN: 'Start Capital',
  ADMIN: 'Administrador',
  USER: 'Vendedor',
  SUPERVISOR: 'Supervisor',
  MANAGER: 'Gerente',
  LEADER: 'Líder',
  SUPPORT: 'Suporte',
}

export interface CurrentUserResponse {
  _id: string
  name: string
  email: string
  profileImageUrl: string
  phone: string
  birthDate: string
  role: UserRoleEnum
  secondRole: UserRoleEnum
  address: {
    zipCode: string
    state: string
    city: string
    neighborhood: string
    street: string
    number: string
  }
  bankAccount: {
    bank: string
    agency: string
    account: string
    accountType: string
    pixKey: string
    pixType: string
    payday: number
  }
  team: {
    _id: string
    name: string
    manager: {
      _id: string
      name: string
    }
    leader: {
      _id: string
      name: string
    }
  }
  myTeam: {
    _id: string
    name: string
  }
  transactions: {
    count: number
    total: number
    lastMonth: number
    lastTransaction: string
  }
  commissionRate: number
  customerCount: number
  isActive: boolean
  isDeleted: boolean
  isPinProtected: boolean
  isUpdatedBy: string
  reasonToDisable: string
  lastAccess: string
  createdAt: string
  updatedAt: string
}

export async function currentUser() {
  const { data } = await httpClient.get<CurrentUserResponse>('/user/me')

  return data
}
